export const DateFormat ='DD-MMM-YYYY'
export const DateWithTimeFormate = 'DD-MMM-YYYY HH:mm'
